import { InvoiceExpandedSummary } from '@melio/ar-domain';
import { Group, SectionBanner } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

import { InvoiceActionsHandlers } from '../../../utils';
import { useInvoiceSectionBannerDetails } from '../hooks';
import { InvoiceBasicDetails } from './InvoiceBasicDetails';
import { InvoicePaymentSummeryDetails } from './InvoicePaymentSummeryDetails';
import { InvoiceSummaryTitle } from './InvoiceSummaryTitle';

type DrawerBodyProps = {
  expandedInvoice: InvoiceExpandedSummary;
  companyName: string;
  invoiceActions: InvoiceActionsHandlers;
};

export const InvoiceSummary = forwardRef<DrawerBodyProps>(({ companyName, expandedInvoice, invoiceActions }, ref) => {
  const { getSectionBannerVariant, getSectionBannerDescription, getSectionBannerTitle, getSectionBannerIcon } =
    useInvoiceSectionBannerDetails();

  const icon = getSectionBannerIcon(expandedInvoice.displayStatus);

  return (
    <Group variant="vertical" spacing="l" ref={ref}>
      <SectionBanner
        description={getSectionBannerDescription({ invoice: expandedInvoice, invoiceActions })}
        showIcon
        title={getSectionBannerTitle({
          displayStatus: expandedInvoice.displayStatus,
          dueDate: expandedInvoice.dueDate,
          paidAt: expandedInvoice.receivablePaymentDetails?.paidAt,
        })}
        variant={getSectionBannerVariant(expandedInvoice.displayStatus)}
        icon={icon ?? undefined}
      />
      <Group variant="vertical" spacing="m">
        <InvoiceSummaryTitle expandedInvoice={expandedInvoice} />
        <InvoiceBasicDetails expandedInvoice={expandedInvoice} companyName={companyName} />
        <InvoicePaymentSummeryDetails expandedInvoice={expandedInvoice} />
      </Group>
    </Group>
  );
});
